import React from 'react';
import PropTypes from 'prop-types';

import {blueColor} from "assets/jss/main";

ShippingMethodName.propTypes = {
    name: PropTypes.string.isRequired
};

function ShippingMethodName({name}) {
    return (
        <span
            style={{
                color: blueColor,
                fontWeight: 600
            }}
        >
            {name}
        </span>
    );
}

export default ShippingMethodName;
